import { Modal } from 'antd';
import './ModalGallery.scss';
import React, { useRef, useState } from 'react';
import img from '../../../assets/images/vr-for-medical 1.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { useSelector } from 'react-redux';

const ModalGallery = ({ open, setOpen, images }) => {
  const { currentLang } = useSelector((state) => state.user);
  const mainSwiperRef = useRef(null);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const galleryData = images?.map((item) => {
    return {
      id: item?.order,
      img: item?.image,
    };
  });
  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      centered
      className="modal-gallery"
    >
      <div className="swiper-container">
        <Swiper
          // style={{ height: '100%',direction: currentLang === 'ar' ? 'rtl' : 'ltr' }}
          // freeMode
          // centeredSlides
          // grabCursor
          // direction={currentLang === 'ar' ? 'rtl' : 'ltr'}
          onSwiper={(swiper) => {
            setThumbsSwiper(swiper);
            mainSwiperRef.current = swiper;
          }}
          spaceBetween={10}
          navigation={{
            nextEl: '.right-arrow',
            prevEl: '.left-arrow',
          }}
          speed={600}
          thumbs={thumbsSwiper ? { swiper: thumbsSwiper } : undefined}
          modules={[FreeMode, Navigation, Thumbs]}
          className="mySwiper2"
          slidesPerView={1}
          slidesPerGroup={1}
          loop={true}
          loopFillGroupWithBlank={true}
        >
          {galleryData?.map((item) => {
            return (
              <SwiperSlide
                key={item.id}
                // style={{
                //   width: '100%',
                //   height: '700px',
                //   objectFit: 'cover',
                // }}
                className="swiper-slide-responsive-active"
              >
                <img
                  src={item.img}
                  alt="Nature 1"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </SwiperSlide>
            );
          })}
          <div className="swiper--arrows">
            <div
              className="left-arrow arrow"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
              }}
              onClick={() => mainSwiperRef.current?.slidePrev()}
            >
              {currentLang === 'ar' ? <FaArrowRight /> : <FaArrowLeft />}
            </div>
            <div
              className="right-arrow arrow"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
              }}
              onClick={() => mainSwiperRef.current?.slideNext()}
            >
              {currentLang === 'ar' ? <FaArrowLeft /> : <FaArrowRight />}
            </div>
          </div>
        </Swiper>
      </div>
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={galleryData?.length}
        freeMode={true}
        speed={600}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper"
      >
        {galleryData?.map((item) => {
          return (
            <SwiperSlide
              key={item.id}
              style={{
                width: '100%',
                height: '80px',
                objectFit: 'cover',
              }}
              // className="swiper-slide-responsive"
            >
              <img
                src={item.img}
                alt="Nature 1"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </Modal>
  );
};

export default ModalGallery;
